import { useState } from 'react';
import { content } from '../data/content';
import { BuyButton, SectionHeading } from './ui/Ui';

/**
 * الأسئلة هنا ليست معلومات عامة — كل سؤال يقتل اعتراضاً حقيقياً يمنع الطلب
 * (الدفع، التوصيل، الإرجاع، حرق القماش، وأخيراً السعر بعد بناء القيمة).
 * أول سؤال مفتوح افتراضياً لأنه أكثر ما يقلق العميل: كيف أدفع؟
 */
export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-16 md:scroll-mt-20 py-10 md:py-20 bg-white">
      <div className="container mx-auto">
        <SectionHeading
          eyebrow={content.faqEyebrow}
          icon="fa-circle-question"
          iconColor="text-z-red"
          title={content.faqTitle}
        />

        <div className="space-y-4 max-w-3xl mx-auto">
          {content.faqItems.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.q}
                className={`bg-z-light border rounded-xl overflow-hidden transition-colors ${
                  isOpen ? 'border-z-red/40' : 'border-gray-200'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full text-start px-6 py-4 font-semibold flex justify-between items-center gap-4 focus:outline-none text-z-navy"
                >
                  <span>{item.q}</span>
                  <i
                    className={`fa-solid fa-chevron-down transition-transform duration-300 text-z-red shrink-0 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 pt-1 text-z-gray text-sm leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex justify-center mt-12">
          <BuyButton label={content.headerCta} />
        </div>
      </div>
    </section>
  );
}
